import styled from '../../styles/styled';
import { Flex } from '../layout/flex';
export const Notification = styled(Flex)(({ theme }) => ({
    position: 'absolute',
    top: '-5px',
    zIndex: 1,
    left: 10,
    height: theme.space[4],
    lineHeight: '10px',
    background: theme.colors.red50,
    color: theme.text.color.light,
    fontSize: theme.text.size.small,
    fontFamily: theme.text.bodyFontFamily,
}));
export const Container = styled.div({
    position: 'relative',
    display: 'flex',
    alignContent: 'center',
});
//# sourceMappingURL=notification_wrapper.styles.js.map